<template>
  <div class="dashboard main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Informações do cliente</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row>
          <b-col>
            <div class="box-cj">
              <div class="header">
                Dados do cliente
              </div>
              <div class="content">
                <b-row class="mb-2">
                  <div class="logo-container">
                    <div id="clientLogo" class="client-logo rounded" title="Marca"></div>
                  </div>
                  <b-col>
                    <label class="cj-label">Nome</label>
                    <b-form-input type="text" v-model="client.name" :disabled="!canEdit"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">E-mail</label>
                    <b-form-input type="text" v-model="client.email" :disabled="!canEdit"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">CPF / CNPJ</label>
                    <b-form-input type="text" v-model="client.document" :disabled="!canEdit" v-mask="['###.###.###-##', '##.###.###/####-##']"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Telefone</label>
                    <b-form-input type="text" v-model="client.telephone" v-mask="(client.telephone != null && client.telephone.length == 15)?'(##) #####-####':'(##) ####-#####'" :disabled="!canEdit"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Celular / Whatsapp</label>
                    <b-form-input type="text" v-model="client.cellphone" v-mask="'(##) #####-####'" :disabled="!canEdit"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">Descrição</label>
                    <b-textarea rows="3" v-model="client.description" :disabled="!canEdit"></b-textarea>
                  </b-col>
                </b-row>
                <hr>
                <p class="mb-1">Gestor</p>
                <b-row class="mb-1">
                  <b-col>
                    <label class="cj-label">Nome</label>
                    <b-form-input type="text" v-model="client.manager.name" :disabled="!canEdit"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">E-mail</label>
                    <b-form-input type="text" v-model="client.manager.email" :disabled="!canEdit"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Telefone</label>
                    <b-form-input type="text" v-model="client.manager.telephone" v-mask="(client.manager.telephone != null && client.manager.telephone.length == 15)?'(##) #####-####':'(##) ####-#####'" :disabled="!canEdit"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Celular / Whatsapp</label>
                    <b-form-input type="text" v-model="client.manager.cellphone" v-mask="'(##) #####-####'" :disabled="!canEdit"></b-form-input>
                  </b-col>
                </b-row>
              </div>
              <div class="footer" v-if="canEdit">
                <b-button variant="primary" class="mr-3" @click="saveConfiguration">Salvar</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="title">Gerais</p>
                  <div>
                    <i class="fa fa-circle ml-2 -pull-right" :title="getSituation(client).name" :class="'situation-indicator ' + getSituation(client).class"></i>
                  </div>
                </div>
              </div>
              <div class="content">
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">Plano</label>
                    <b-form-input type="text" :value="client.subscription != null ? client.plans.plans.find(d => d.plan == client.subscription.plan).name : ''" :disabled="true"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Nº de agendas</label>
                    <b-form-input type="text" :value="client.agendas_count" :disabled="true"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Números de Whatsapp</label>
                    <b-form-input type="text" :value="client.whatsapps_count" :disabled="true"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Minutos de teleconsultas</label>
                    <b-form-input type="text" :value="client.subscription != null ? client.subscription.minutes : 0" :disabled="true"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Vencimento</label>
                    <b-form-input type="text" :value="client.subscription != null && client.subscription.status == 'ACTIVE' ? moment(client.subscription.valid_until).format('DD/MM/YYYY') : client.trial_ends_at" :disabled="true"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Data de cadastro</label>
                    <b-form-input type="text" :value="client.created_at" :disabled="true"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">Último acesso</label>
                    <b-form-input type="text" :value="client.last_access" :disabled="true"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Último agendamento</label>
                    <b-form-input type="text" :value="client.last_appointment_created_at" :disabled="true"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Situação</label>
                    <b-form-input type="text" :value="getSituation(client).name" :disabled="true"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col cols="4">
                    <label class="cj-label">Status</label>
                    <multiselect v-model="client.status" :options="statusOptions" track-by="name" label="name" :preselect-first="true" :showLabels="false" :allow-empty="false" :searchable="false" :disabled="!canManage"></multiselect>
                  </b-col>
                  <b-col cols="4">
                    <label class="cj-label">Periodicidade de cobrança</label>
                    <multiselect v-model="client.subscription_charge_period" :options="subscriptionChargePeriodOptions" track-by="name" label="name" :preselect-first="true" :showLabels="false" :allow-empty="false" :searchable="false" :disabled="!canManage"></multiselect>
                  </b-col>
                  <b-col cols="4">
                    <label class="cj-label">Habilitar boleto e Pix X dias antes do vencimento</label>
                    <validation-provider name="habilitar boleto e Pix X dias antes do vencimento" :rules="{ required: true }" v-slot="{ errors }">
                      <b-form-input type="number" v-model="client.allow_boleto_pix_days_before_subscription_end" :class="{ 'error': errors.length > 0 }" autocomplete="off" :disabled="!canManage"></b-form-input>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                </b-row>
                <hr>
                <p class="mb-1">Valores personalizados - Planos</p>
                <b-row class="mb-1">
                  <b-col>
                    <div class="pretty positive p-default">
                      <input type="checkbox" v-model="plan_0_price_enabled" />
                      <div class="state p-success">
                        <label class="cj-label">Plano Atendimento</label>
                      </div>
                    </div>
                    <validation-provider name="plano atendimento" :rules="{ required: false }" v-slot="{ errors }">
                      <money v-model="client.plan_0_price" class="form-control mb-2" :disabled="!canManage || !plan_0_price_enabled" :class="{ 'error': errors.length > 0 }"></money>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                  <b-col>
                    <div class="pretty positive p-default">
                      <input type="checkbox" v-model="plan_1_price_enabled" />
                      <div class="state p-success">
                        <label class="cj-label">Plano Gestão Completa</label>
                      </div>
                    </div>
                    <validation-provider name="plano gestão completa" :rules="{ required: false }" v-slot="{ errors }">
                      <money v-model="client.plan_1_price" class="form-control mb-2" :disabled="!canManage || !plan_1_price_enabled" :class="{ 'error': errors.length > 0 }"></money>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                  <b-col>
                    <div class="pretty positive p-default">
                      <input type="checkbox" v-model="plan_2_price_enabled" />
                      <div class="state p-success">
                        <label class="cj-label">Plano Teleconsulta</label>
                      </div>
                    </div>
                    <validation-provider name="plano teleconsulta" :rules="{ required: false }" v-slot="{ errors }">
                      <money v-model="client.plan_2_price" class="form-control mb-2" :disabled="!canManage || !plan_2_price_enabled" :class="{ 'error': errors.length > 0 }"></money>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                  <b-col>
                    <validation-provider name="valores válidos até" :rules="{ required: false }" v-slot="{ errors }">
                      <label class="cj-label">Valores válidos até</label>
                      <date-picker name="date" v-model="client.reset_plan_prices_date" v-mask="'##/##/####'" :disabled="reset_plan_prices_date_disabled || (!plan_0_price_enabled && !plan_1_price_enabled && !plan_2_price_enabled)" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                    <div class="text-center">
                      <div class="pretty p-switch p-fill">
                        <input type="checkbox" v-model="reset_plan_prices_date_disabled" :disabled="!canManage || (!plan_0_price_enabled && !plan_1_price_enabled && !plan_2_price_enabled)" />
                        <div class="state p-success">
                          <label><span>Validade indefinida</span></label>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <hr>
                <p class="mb-1">Valores personalizados - Adicionais</p>
                <b-row class="mb-1">
                  <b-col>
                    <div class="pretty positive p-default">
                      <input type="checkbox" v-model="agendas_price_enabled" />
                      <div class="state p-success">
                        <label class="cj-label">Agenda Inteligente</label>
                      </div>
                    </div>
                    <validation-provider name="agenda inteligente" :rules="{ required: false }" v-slot="{ errors }">
                      <money v-model="client.agendas_price" class="form-control mb-2" :disabled="!canManage || !agendas_price_enabled" :class="{ 'error': errors.length > 0 }"></money>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                  <b-col>
                    <validation-provider name="valor de agenda válido até" :rules="{ required: false }" v-slot="{ errors }">
                      <label class="cj-label">Valor de agenda válido até</label>
                      <date-picker name="date" v-model="client.reset_agendas_price_date" v-mask="'##/##/####'" :disabled="reset_agendas_price_date_disabled || !agendas_price_enabled" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                    <div class="text-center">
                      <div class="pretty p-switch p-fill">
                        <input type="checkbox" v-model="reset_agendas_price_date_disabled" :disabled="!canManage || !agendas_price_enabled" />
                        <div class="state p-success">
                          <label><span>Validade indefinida</span></label>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col>
                    <div class="pretty positive p-default">
                      <input type="checkbox" v-model="whatsapps_price_enabled" />
                      <div class="state p-success">
                        <label class="cj-label">Número de Whatsapp</label>
                      </div>
                    </div>
                    <validation-provider name="número de whatsapp" :rules="{ required: false }" v-slot="{ errors }">
                      <money v-model="client.whatsapps_price" class="form-control mb-2" :disabled="!canManage || !whatsapps_price_enabled" :class="{ 'error': errors.length > 0 }"></money>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                  <b-col>
                    <validation-provider name="valor de número de whatsapp válido até" :rules="{ required: false }" v-slot="{ errors }">
                      <label class="cj-label">Valor de número de Whatsapp válido até</label>
                      <date-picker name="date" v-model="client.reset_whatsapps_price_date" v-mask="'##/##/####'" :disabled="reset_whatsapps_price_date_disabled || !whatsapps_price_enabled" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                    <div class="text-center">
                      <div class="pretty p-switch p-fill">
                        <input type="checkbox" v-model="reset_whatsapps_price_date_disabled" :disabled="!canManage || !whatsapps_price_enabled" />
                        <div class="state p-success">
                          <label><span>Validade indefinida</span></label>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col>
                    <div class="pretty positive p-default">
                      <input type="checkbox" v-model="minutes_price_enabled" />
                      <div class="state p-success">
                        <label class="cj-label">Minutos de teleconsultas</label>
                      </div>
                    </div>
                    <validation-provider name="minutos de teleconsultas" :rules="{ required: false }" v-slot="{ errors }">
                      <money v-model="client.minutes_price" class="form-control mb-2" :disabled="!canManage || !minutes_price_enabled" :class="{ 'error': errors.length > 0 }"></money>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                  <b-col>
                    <validation-provider name="valor válido até" :rules="{ required: false }" v-slot="{ errors }">
                      <label class="cj-label">Valor de minutos válido até</label>
                      <date-picker name="date" v-model="client.reset_minutes_price_date" v-mask="'##/##/####'" :disabled="reset_minutes_price_date_disabled || !minutes_price_enabled" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                    <div class="text-center">
                      <div class="pretty p-switch p-fill">
                        <input type="checkbox" v-model="reset_minutes_price_date_disabled" :disabled="!canManage || !minutes_price_enabled" />
                        <div class="state p-success">
                          <label><span>Validade indefinida</span></label>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="footer" v-if="canManage">
                <b-button variant="primary" class="mr-3" @click="saveConfiguration">Salvar</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="title">Afiliado</p>
                  <div>
                    <a :href="'https://consultaja.com/' + client.affiliate_account_slug" v-if="(enable_affiliate_account || client.affiliate_account_id != null)" target="_blank" class="mr-3"><i class="far fa-link"></i></a>
                    <div class="pretty p-switch p-fill" v-if="client.affiliate_account_id == null">
                      <input type="checkbox" v-model="enable_affiliate_account" />
                      <div class="state p-success">
                        <label></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content" v-if="(enable_affiliate_account || client.affiliate_account_id != null)">
                <b-row class="mb-3">
                  <b-col>
                    <label class="cj-label">URL</label>
                    <validation-provider name="url" :rules="{ required: true, regex: '^[a-z0-9]+(?:-[a-z0-9]+)*$' }" v-slot="{ errors }">
                      <b-form-input type="text" v-model="client.affiliate_account_slug" :class="{ 'error': errors.length > 0 }"></b-form-input>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                </b-row>
              </div>
              <div class="footer" v-if="canManage && (enable_affiliate_account || client.affiliate_account_id != null)">
                <b-button variant="primary" class="mr-3" @click="saveConfiguration">Salvar</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="box-cj">
              <div class="header">
                Endereço
              </div>
              <div class="content">
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">CEP</label>
                    <b-form-input type="tel" v-model="client.address.zip_code" v-mask="'#####-###'" :disabled="!canEdit" v-on:blur="findCep(client.address.zip_code)"></b-form-input>
                  </b-col>
                  <b-col cols="8">
                    <label class="cj-label">Endereço</label>
                    <b-form-input type="text" v-model="client.address.address" ref="address" :disabled="!canEdit"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Número</label>
                    <b-form-input type="tel" v-model="client.address.number" ref="number" :disabled="!canEdit"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">Complemento</label>
                    <b-form-input type="text" v-model="client.address.complement" :disabled="!canEdit"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Bairro</label>
                    <b-form-input type="text" v-model="client.address.neighborhood" :disabled="!canEdit"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Cidade</label>
                    <b-form-input type="text" v-model="client.address.city" :disabled="!canEdit"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Estado</label>
                    <b-form-input type="text" v-model="client.address.state" :disabled="!canEdit"></b-form-input>
                  </b-col>
                </b-row>
              </div>
              <div class="footer" v-if="canEdit">
                <b-button variant="primary" class="mr-3" @click="saveConfiguration">Salvar</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="box-cj">
              <div class="header">
                Configurações
              </div>
              <div class="content">
                <b-row class="mb-2">
                  <b-col>
                    <div class="pretty p-switch p-fill mr-0">
                      <input type="checkbox" v-model="share_patients" :disabled="!canEdit"/>
                      <div class="state p-success">
                        <label><span>Compartilhar pacientes com todos os profissionais</span></label>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <div class="pretty p-switch p-fill mr-0">
                      <input type="checkbox" v-model="share_forms" :disabled="!canEdit"/>
                      <div class="state p-success">
                        <label><span>Compartilhar prontuários com todos os profissionais</span></label>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <div class="pretty p-switch p-fill mr-0">
                      <input type="checkbox" v-model="enable_digital_prescriptions" :disabled="!canEdit"/>
                      <div class="state p-success">
                        <label><span>Permitir emissão de receituário digital</span></label>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <div class="pretty p-switch p-fill mr-0">
                      <input type="checkbox" v-model="enable_simultaneous_attendances" :disabled="!canEdit"/>
                      <div class="state p-success">
                        <label><span>Permitir atendimentos simultâneos</span></label>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <div class="pretty p-switch p-fill mr-0">
                      <input type="checkbox" v-model="enable_professional_notes" :disabled="!canEdit"/>
                      <div class="state p-success">
                        <label><span>Permitir anotações no prontuário pelo profissional</span></label>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="footer" v-if="canEdit">
                <b-button variant="primary" class="mr-3" @click="saveConfiguration">Salvar</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="box-cj">
              <div class="header">
                Funcionalidades
              </div>
              <div class="content">
                <b-row class="mb-2">
                  <b-col>
                    <div class="pretty p-switch p-fill mr-0">
                      <input type="checkbox" v-model="show_whatsapp_options"/>
                      <div class="state p-success">
                        <label><span>Habilitar configuração de mensagens de Whatsapp</span></label>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <div class="pretty p-switch p-fill mr-0">
                      <input type="checkbox" v-model="hide_cancel_in_messages"/>
                      <div class="state p-success">
                        <label><span>Ocultar o "Não" das mensagens de confirmação de consulta</span></label>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <div class="pretty p-switch p-fill mr-0">
                      <input type="checkbox" v-model="enable_coordinator_profile" :disabled="!canManage"/>
                      <div class="state p-success">
                        <label><span>Habilitar perfil de coordenador</span></label>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <div class="pretty p-switch p-fill mr-0">
                      <input type="checkbox" v-model="enable_multi_professional_telehealth_attendance" :disabled="!canManage"/>
                      <div class="state p-success">
                        <label><span>Habilitar Teleconsulta com multi profissionais</span></label>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="footer" v-if="canManage">
                <b-button variant="primary" class="mr-3" @click="saveConfiguration">Salvar</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        canSee: true,
        canManage: true,
        canEdit: true,

        enable_affiliate_account: false,

        currentLogo: null,
        logoFile: null,

        share_patients: false,
        share_forms: false,
        enable_digital_prescriptions: false,
        enable_simultaneous_attendances: false,
        enable_professional_notes: false,
        enable_multi_professional_telehealth_attendance: false,
        show_whatsapp_options: false,
        hide_cancel_in_messages: false,
        enable_coordinator_profile: false,

        statusOptions: [
          { value: 'ACTIVE', name: 'Ativo' },
          { value: 'INACTIVE', name: 'Inativo' },
          { value: 'SUSPENDED', name: 'Suspenso' }
        ],

        subscriptionChargePeriodOptions: [
          { value: 1, name: 'Mensal' },
          { value: 2, name: 'Bimestral' },
          { value: 3, name: 'Trimestral' },
          { value: 6, name: 'Semestral' },
          { value: 12, name: 'Anual' }
        ],

        situationOptions: [
          { value: 'USING', name: 'Usando', class: 'using' },
          { value: 'STOPPED_USING', name: 'Deixou de usar', class: 'stopped-using' },
          { value: 'NOT_USING_ANYMORE', name: 'Não usa mais', class: 'not-using-anymore' },
          { value: 'NEVER_USED', name: 'Não usou', class: 'never-used' }
        ],

        plan_0_price_enabled: false,
        plan_1_price_enabled: false,
        plan_2_price_enabled: false,
        reset_plan_prices_date_disabled: false,
        agendas_price_enabled: false,
        reset_agendas_price_date_disabled: false,
        whatsapps_price_enabled: false,
        reset_whatsapps_price_date_disabled: false,
        minutes_price_enabled: false,
        reset_minutes_price_date_disabled: false,

        datePickerOptions: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          locale: 'pt-br'
        },

        client: {
          id: null,
          status: null,
          subscription_charge_period: null,
          agendas_count: 0,
          whatsapps_count: 0,
          minutes: 0,
          plan_0_price: 0,
          plan_1_price: 0,
          plan_2_price: 0,
          reset_plan_prices_date: '',
          agendas_price: 0,
          reset_agendas_price_date: '',
          whatsapps_price: 0,
          reset_whatsapps_price_date: '',
          minutes_price: 0,
          reset_minutes_price_date: '',
          allow_boleto_pix_days_before_subscription_end: 3,
          subscription: null,
          last_access: null,
          created_at: null,
          trial_ends_at: null,
          last_appointment_created_at: null,
          logo: null,
          delete_logo: false,
          name: null,
          email: null,
          document: null,
          telephone: null,
          cellphone: null,
          description: null,
          affiliate_account_id: null,
          affiliate_account_slug: null,
          manager: {
            name: null,
            email: null,
            telephone: null,
            cellphone: null,
          },
          address: {
            id: null,
            zip_code: null,
            address: null,
            number: null,
            complement: null,
            neighborhood: null,
            city: null,
            state: null,
            country: 'Brazil',
          }
        }
      }
    },
    mounted () {
      this.canSee = true;
      this.canManage = true;
      this.canEdit = false;

      this.eventBus.$emit('IS_LOADING', true);
      this.api.getClient(this.$route.params.id).then(res => {
        let clientData = res.data;
        this.client = clientData;
        if(clientData.address == null) {
          this.client.address = {
            id: null,
            zip_code: null,
            address: null,
            number: null,
            complement: null,
            neighborhood: null,
            city: null,
            state: null,
            country: 'Brazil',
          };
        }
        this.client.plan_0_price = (this.client.plans.plans.find(d => d.plan == 0).price_in_cents)/100.0;
        this.plan_0_price_enabled = this.client.plan_0_price_in_cents != null;
        this.client.plan_1_price = (this.client.plans.plans.find(d => d.plan == 1).price_in_cents)/100.0;
        this.plan_1_price_enabled = this.client.plan_1_price_in_cents != null;
        this.client.plan_2_price = (this.client.plans.plans.find(d => d.plan == 2).price_in_cents)/100.0;
        this.plan_2_price_enabled = this.client.plan_2_price_in_cents != null;
        this.client.reset_plan_prices_date = this.client.reset_plan_prices_date != null ? this.moment(this.client.reset_plan_prices_date).format('DD/MM/YYYY') : '';
        this.reset_plan_prices_date_disabled = this.client.reset_plan_prices_date == '';

        this.client.agendas_price = this.client.plans.extra_agendas.price_in_cents/100.0;
        this.agendas_price_enabled = this.client.agendas_price_in_cents != null;
        this.client.reset_agendas_price_date = this.client.reset_agendas_price_date != null ? this.moment(this.client.reset_agendas_price_date).format('DD/MM/YYYY') : '';
        this.reset_agendas_price_date_disabled = this.client.reset_agendas_price_date == '';

        this.client.whatsapps_price = this.client.plans.extra_whatsapps.price_in_cents/100.0;
        this.whatsapps_price_enabled = this.client.whatsapps_price_in_cents != null;
        this.client.reset_whatsapps_price_date = this.client.reset_whatsapps_price_date != null ? this.moment(this.client.reset_whatsapps_price_date).format('DD/MM/YYYY') : '';
        this.reset_whatsapps_price_date_disabled = this.client.reset_whatsapps_price_date == '';

        this.client.minutes_price = this.client.plans.telehealth_minutes.price_in_cents/100.0;
        this.minutes_price_enabled = this.client.minutes_price_in_cents != null;
        this.client.reset_minutes_price_date = this.client.reset_minutes_price_date != null ? this.moment(this.client.reset_minutes_price_date).format('DD/MM/YYYY') : '';
        this.reset_minutes_price_date_disabled = this.client.reset_minutes_price_date == '';

        this.client.status = this.statusOptions.find(g => g.value == clientData.status);
        this.client.subscription_charge_period = this.subscriptionChargePeriodOptions.find(g => g.value == clientData.subscription_charge_period);
        this.client.last_access = clientData.last_access != null ? this.moment(clientData.last_access).format('DD/MM/YYYY') : '';
        this.client.trial_ends_at = this.moment(clientData.created_at).add(7, 'days').format('DD/MM/YYYY');
        this.client.created_at = this.moment(clientData.created_at).format('DD/MM/YYYY');
        this.client.last_appointment_created_at = clientData.last_appointment_created_at != null ? this.moment(clientData.last_appointment_created_at).format('DD/MM/YYYY') : '';
        this.share_patients = clientData.share_patients;
        this.share_forms = clientData.share_forms;
        this.enable_digital_prescriptions = clientData.enable_digital_prescriptions;
        this.enable_simultaneous_attendances = clientData.enable_simultaneous_attendances;
        this.enable_professional_notes = clientData.enable_professional_notes;
        this.show_whatsapp_options = clientData.show_whatsapp_options;
        this.hide_cancel_in_messages = clientData.hide_cancel_in_messages;
        this.enable_coordinator_profile = clientData.enable_coordinator_profile;
        this.enable_multi_professional_telehealth_attendance = clientData.enable_multi_professional_telehealth_attendance;
        this.currentLogo = clientData.logo;
        this.updateLogo();

        if(this.client.affiliate_account_slug == null) {
          this.client.affiliate_account_slug = this.slugify(clientData.name);
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Client', res);

        this.eventBus.$emit('IS_LOADING', false);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        this.$router.push({path: '/'});

        this.$swal('Ops...', 'Não conseguimos carregar os dados do cliente! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Client', err.response);
      });
    },
    methods: {
      saveConfiguration () {
        let clientData = {
          status: this.client.status.value,
          subscription_charge_period: this.client.subscription_charge_period.value,
          allow_boleto_pix_days_before_subscription_end: this.client.allow_boleto_pix_days_before_subscription_end,
          show_whatsapp_options: this.show_whatsapp_options,
          hide_cancel_in_messages: this.hide_cancel_in_messages,
          enable_coordinator_profile: this.enable_coordinator_profile,
          enable_multi_professional_telehealth_attendance: this.enable_multi_professional_telehealth_attendance,
          plan_0_price_in_cents: null,
          plan_1_price_in_cents: null,
          plan_2_price_in_cents: null,
          agendas_price_in_cents: null,
          whatsapps_price_in_cents: null,
          minutes_price_in_cents: null,
          reset_plan_prices_date: null,
          reset_agendas_price_date: null,
          reset_whatsapps_price_date: null,
          reset_minutes_price_date: null,
        };
        if(this.plan_0_price_enabled) {
          clientData.plan_0_price_in_cents = parseInt(this.client.plan_0_price * 100.0);
        }
        if(this.plan_1_price_enabled) {
          clientData.plan_1_price_in_cents = parseInt(this.client.plan_1_price * 100.0);
        }
        if(this.plan_2_price_enabled) {
          clientData.plan_2_price_in_cents = parseInt(this.client.plan_2_price * 100.0);
        }
        if((this.plan_0_price_enabled || this.plan_1_price_enabled || this.plan_2_price_enabled) && !this.reset_plan_prices_date_disabled) {
          clientData.reset_plan_prices_date = this.client.reset_plan_prices_date;
        }
        if(this.agendas_price_enabled) {
          clientData.agendas_price_in_cents = parseInt(this.client.agendas_price * 100.0);
        }
        if(this.agendas_price_enabled && !this.reset_agendas_price_date_disabled) {
          clientData.reset_agendas_price_date = this.client.reset_agendas_price_date;
        }
        if(this.whatsapps_price_enabled) {
          clientData.whatsapps_price_in_cents = parseInt(this.client.whatsapps_price * 100.0);
        }
        if(this.whatsapps_price_enabled && !this.reset_whatsapps_price_date_disabled) {
          clientData.reset_whatsapps_price_date = this.client.reset_whatsapps_price_date;
        }
        if(this.minutes_price_enabled) {
          clientData.minutes_price_in_cents = parseInt(this.client.minutes_price * 100.0);
        }
        if(this.minutes_price_enabled && !this.reset_minutes_price_date_disabled) {
          clientData.reset_minutes_price_date = this.client.reset_minutes_price_date;
        }


        if(this.enable_affiliate_account || this.client.affiliate_account_id != null) {
          clientData.enable_affiliate_account = true;
          clientData.affiliate_account_id = this.client.affiliate_account_id;
          clientData.affiliate_account_slug = this.client.affiliate_account_slug;
        }
        this.api.saveClientConfiguration(this.client.id, clientData).then(res => {
          if(res.status == 200) {
            this.$swal('Uhull \\o/', 'Os dados do cliente foram atualizados com sucesso!', 'success').then(() => {
              this.$router.go();
            });
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Update Client', res);
        }).catch(err => {
          let msg = 'Não conseguimos atualizar os dados do cliente! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 400:
              msg = err.response.data.message;
              break;
            case 422:
              msg = err.response.data.errors.join('\r\n');
              break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Update Client', err.response);
        });
      },

      updateLogo() {
        let logo = '';
        if(this.client.logo != null) {
          logo = this.client.logo;
        } else if(this.currentLogo != null) {
          logo = this.currentLogo;
        } else {
          logo = 'https://via.placeholder.com/70x70/eaf1f4/11a6f3';
        }
        document.getElementById('clientLogo').style.backgroundImage = 'url("' + logo + '")';
      },

      findCep(value) {
        if(value == '00000-000' || value == '99999-999') {
          this.client.address.address = 'Atendimento online';
          this.client.address.number = '-';
          this.client.address.neighborhood = '-';
          this.client.address.city = '-';
          this.client.address.state = '-';
        } else if(value.length == 9) {
          axios.get('https://viacep.com.br/ws/'+value+'/json/').then(res => {
            if(typeof res.data.erro == 'undefined') {
              let cepData = res.data;
              this.client.address.address = cepData.logradouro;
              this.client.address.neighborhood = cepData.bairro;
              this.client.address.city = cepData.localidade;
              this.client.address.state = cepData.uf;

              this.$refs.number.$el.focus();
            } else {

              this.$refs.address.$el.focus();
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response CEP', res);
          }).catch(err => {
            this.$swal('Ops...', 'Não conseguimos localizar o seu CEP! Por favor, preencha os dados manualmente.', 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error CEP', err.response);
          });
        }
      },

      getSituation(client) {
        let situation = '';
        if(client.last_appointment_created_at == null || client.last_appointment_created_at == '')
          situation = 'NEVER_USED';
        else if(client.days_without_use <= 4)
          situation = 'USING';
        else if(client.days_without_use <= 15)
          situation = 'STOPPED_USING';
        else
          situation = 'NOT_USING_ANYMORE';

        return this.situationOptions.find(g => g.value == situation);
      },

      slugify(text) {
        return text
            .toString()                     // Cast to string
            .toLowerCase()                  // Convert the string to lowercase letters
            .normalize('NFD')       // The normalize() method returns the Unicode Normalization Form of a given string.
            .trim()                         // Remove whitespace from both sides of a string
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w-]+/g, '')       // Remove all non-word chars
            .replace(/--+/g, '-');        // Replace multiple - with single -
      }
    }
  }
</script>

<style lang="scss">
  .dashboard {
    padding: 20px 0;

    .header-info {
      p {
        margin: 0;
      }

      .info {

      }

      .value {
        font-size: 32px;
        color: $linkWater;
      }
    }

    .logo-container {
      position: relative;

      .client-logo {
        cursor: pointer;
        margin-left: 15px;
        width: 70px;
        height: 70px;
        background: #f0f0f0 no-repeat 50%;
        background-size: contain;
        border: 1px solid $linkWater;
      }
    }

    .situation-indicator {
      font-size: 12px;

      &.using {
        color: $ufoGreen;
      }
      &.stopped-using {
        color: $yellowSea;
      }
      &.not-using-anymore {
        color: $dullRed;
      }
      &.never-used {
        color: #333333;
      }
    }
  }
</style>
